import { create } from "zustand";
import type { FeedbackType } from "@/lib/in-app-feedback";

// The in-app "Send feedback" dialog, opened from the menu, the note prompt
// or the workspace assistant.
interface FeedbackState {
  open: boolean;
  // The visit it was opened from, if any.
  visitPublicId: string | null;
  initialType: FeedbackType;
  show: (options?: {
    visitPublicId?: string | null;
    type?: FeedbackType;
  }) => void;
  hide: () => void;
}

export const useFeedbackStore = create<FeedbackState>()((set) => ({
  open: false,
  visitPublicId: null,
  initialType: "bug",
  show: (options = {}) => {
    set({
      open: true,
      visitPublicId: options.visitPublicId ?? null,
      initialType: options.type ?? "bug",
    });
  },
  hide: () => {
    set({ open: false });
  },
}));
